import axios from 'axios';

// API base URL - production'da Render URL'ini kullan
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const API_URL = `${API_BASE_URL}/api`;

// Axios instance oluştur
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - token ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - token geçersizlik hatalarını yakala
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 hatası alındığında ve login/register endpoint'leri değilse otomatik logout yap
    if (error.response?.status === 401 && 
        !error.config?.url?.includes('/auth/login') && 
        !error.config?.url?.includes('/auth/register') &&
        !error.config?.url?.includes('/auth/forgot-password') &&
        !error.config?.url?.includes('/auth/reset-password')) {
      
      // Özel hata mesajını kontrol et
      const errorMessage = error.response?.data?.error;
      
      // Token geçersiz, kullanıcıyı çıkış yap
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Hesap pasif durumda ise özel bir mesaj göster
      if (errorMessage === 'Hesabınıza erişilemiyor') {
        // URL'e özel parametre ekle
        window.location.href = '/login?error=account_disabled';
      } else {
        window.location.href = '/login?error=session_expired';
      }
    }
    return Promise.reject(error);
  }
);

// Auth API fonksiyonları
export const authAPI = {
  // Setup durumunu kontrol et
  checkSetup: () => api.get('/auth/check-setup'),
  
  // Kullanıcı kaydı
  register: (userData) => api.post('/auth/register', userData),
  
  // Giriş
  login: (credentials) => api.post('/auth/login', credentials),
  
  // Kullanıcı bilgilerini getir
  getMe: () => api.get('/auth/me'),
  
  // Şifre değiştir
  changePassword: (passwordData) => api.post('/auth/change-password', passwordData),

  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),

  validateResetToken: (token) =>
    api.get('/auth/reset-password/validate', { params: { token } }),

  resetPassword: (payload) => api.post('/auth/reset-password', payload),
  
  // Admin: Normal kullanıcı girişi aç/kapat
  toggleLogin: (enabled) => api.post('/auth/admin/toggle-login', { enabled }),

  // Admin: Register aç/kapat
  toggleRegister: (enabled) => api.post('/auth/admin/toggle-register', { enabled }),
  
  // Admin: Yeni kullanıcı oluştur
  createUser: (userData) => api.post('/auth/admin/create-user', userData),
  
  // Admin: Tüm kullanıcıları getir
  getUsers: () => api.get('/auth/admin/users'),
  
  // Admin: Kullanıcı güncelle
  updateUser: (userId, userData) => api.put(`/auth/admin/users/${userId}`, userData),
  
  // Admin: Kullanıcı sil
  deleteUser: (userId) => api.delete(`/auth/admin/users/${userId}`),
  
  // Admin: Kullanıcı aktif/pasif durumunu değiştir
  toggleUserActive: (userId, isActive) => api.put(`/auth/admin/users/${userId}/toggle-active`, { isActive }),
};

// Admin: E-posta gönderim ayarları
export const emailSettingsAPI = {
  get: () => api.get('/email-settings'),
  /** Test gönderir + başarılıysa kaydeder */
  save: (body) => api.post('/email-settings', body),
  /** Yalnızca test (kaydetmez) — isteğe bağlı */
  testOnly: (body) => api.post('/email-settings/test', body)
};

// Custom collections API
export const collectionsAPI = {
  getCollections: () => api.get('/collections'),
  getCollectionProducts: (id) => api.get(`/collections/${id}/products`),
};

export const vendorsAPI = {
  getVendors: () => api.get('/vendors'),
  getVendorProducts: (name) => api.get('/vendors/products', { params: { name } }),
};

// Products API fonksiyonları
export const productsAPI = {
  // Ürünleri getir
  getProducts: () => api.get('/products'),
  
  // Ürün güncelle
  updateProduct: (id, productData) => api.put(`/products/${id}`, productData),

  updateInventory: (id, quantity) => api.put(`/products/${id}/inventory`, { quantity }),

  bulkUpdateInventory: (items) =>
    api.post('/products/bulk-inventory', { items }, { timeout: 180000 }),
  
  // Toplu fiyat güncelleme
  bulkUpdateProducts: (products) =>
    api.post('/products/bulk-update', { products }, { timeout: 180000 }),
  
  // Toplu fiyat değişimi
  bulkPercentageChange: (data) => api.post('/products/bulk-percentage', data),
};

export default api;
